import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Layout, Row, Col, Button, Avatar, Divider, Popover } from "antd";
import { UserOutlined, CloseCircleFilled, MenuOutlined } from "@ant-design/icons";

import { cleanMenu } from "../../../redux/menu/menuDucks";
import { getUsuarioLogout } from "../../../redux/usuario/usuarioDucks";
// import { openModalLogin } from "../../../redux/aspirante/aspiranteDucks";
import { cleanState } from "../../../redux/aspirante/reqAcademicoDuck";
import { linksRouter } from "../../../config/RouterLink";

import "./HeaderLogin.css";

import { ReactComponent as LogoHeader } from "../../../assets/img/CONCURSO_PUBLICO.svg";
const { Header } = Layout;

/**
 * Component Header que se muestra una vez iniciada la sesión
 * @param {*} props
 * @return {*}  HeaderLogin
 */
function HeaderLogin(props) {
  const { history } = props;
  const dispatch = useDispatch();
  const { autenticado, nombre, apellidos } = useSelector(
    (state) => state.usuarioLogin
  );

  const onLogout = () => {
    // dispatch(openModalLogin()); //oculta el modal del login
    //Se limpia el state del usuario
    dispatch(cleanMenu()); //Se limpia las urls del menú
    dispatch(getUsuarioLogout());
    //Se limpia el state de req academico
    dispatch(cleanState());
    setTimeout(() => {
      history.replace("/");
    }, 1000);
  };

  return (
    <>
        <Header className="mainHeaderAdmin">
            <Row type="flex" align="middle">
                <Col xxl={2} xl={2} lg={2} md={3} sm={3} xs={3} className="container-logo-header text-center">
                    <Link to={linksRouter.home}>
                        <LogoHeader className="logoConcurso" />
                    </Link>
                </Col>
                <Col xxl={10} xl={10} lg={17} md={17} sm={17} xs={16} className="container-titulo-header">
                    <Row>
                        <Col span={1} className="divider_titulo_header">
                            <Divider type="vertical" />
                        </Col>
                        <Col span={23}>
                            <div className="titulo_header">
                                Concursos Públicos de ingreso para ocupar plazas vacantes en cargos<br/>
                                y puestos del Servicio Profesional Electoral Nacional
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={12} xl={12} lg={4} md={4} sm={4} xs={5} className="container-user-header">
                    {autenticado && (
                        <Row>
                            <Col xxl={24} xl={24} lg={0} md={0} sm={0} xs={0}>
                                <Avatar icon={<UserOutlined />}/>
                                <Button
                                    type="text"
                                    className="btn-user-name"
                                >
                                    {`${nombre} ${apellidos}`}
                                </Button>
                                <span style={{ color: "#fff", fontWeight: 600 }}>&#124;</span>
                                <Button
                                    type="text"
                                    className="btn-close-sesion"
                                    onClick={() => onLogout()}
                                >
                                    <CloseCircleFilled />
                                    Cerrar sesión
                                </Button>
                            </Col>
                            <Col xxl={0} xl={0} lg={24} md={24} sm={24} xs={24} className="container-submenu">
                                <Popover content={
                                    <div className="container-header-popover">
                                        <Avatar icon={<UserOutlined />}/>
                                        <Button
                                            type="text"
                                            className="btn-submenu-name"
                                        >
                                            {`${nombre} ${apellidos}`}
                                        </Button>
                                        <Button
                                            type="text"
                                            className="btn-submenu"
                                            onClick={() => onLogout()}
                                        >
                                            <CloseCircleFilled />
                                            Cerrar sesión
                                        </Button>
                                    </div>

                                } title="">
                                    <Button className="btn-hamburguer" type="primary"><MenuOutlined /></Button>
                                </Popover>
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
        </Header>
    </>
  );
}

export default withRouter(HeaderLogin);
